var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-4",class:[_vm.size, _vm.alignment],staticStyle:{"width":"100%"}},[_vm._v(_vm._s(_vm.block.text))])
}
var staticRenderFns = []

export { render, staticRenderFns }